
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAntenna2On as ObiAntenna2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-antenna-2-on.js';
 
 
 

 
 export const ObiAntenna2On = createComponent({
   react: React,
   tagName: 'obi-antenna-2-on',
   elementClass: ObiAntenna2OnElement,
   events: {
     
   }
  });
 
 